export var localizations = {
  player: {
    en: "Player",
    ru: "Игрок",
  },
  opponentStocks: {
    en: "Opponent's stocks",
    ru: "Запасы соперника",
  },
  empty: {
    en: "Empty",
    ru: "Пустой",
  },
  playingField: {
    en: "The playing field",
    ru: "Игровое поле",
  },
  hint: {
    en: "Hint",
    ru: "Подсказка",
  },
  textHint: {
    en: "Drag the tile and place it on the playing field",
    ru: "Перетащите плитку и поместите ее на игровое поле",
  },
  close: {
    en: "Close",
    ru: "Закрыть",
  },
  startOver: {
    en: "Start over",
    ru: "Начать сначала",
  },
  getIt: {
    en: "Get it",
    ru: "Добрать",
  },
  skipMove: {
    en: "Skip a move",
    ru: "Пропустить ход",
  },
  gameStock: {
    en: "Game Stock",
    ru: "Игровой запас",
  },
  emptyStock: {
    en: "Empty",
    ru: "Пусто",
  },
  waiting: {
    en: "Wait, please, the dice are being distributed...",
    ru: "Подождите, пожалуйста, идет раздача костей...",
  },
  winTitle: {
    en: "Congratulations on your victory!",
    ru: "Поздравляю с победой!",
  },
  winDescription: {
    en: "Restart the game to start a new round",
    ru: "Перезапустите игру, чтобы начать новый раунд",
  },
  startOver: {
    en: "Start over",
    ru: "Начать сначала",
  },
  loseTitle: {
    en: "Great game!",
    ru: "Отличная игра!",
  },
  warehouse: {
    en: "Warehouse",
    ru: "СКЛАД",
  },
  you: {
    en: "You",
    ru: "Вы",
  },
  opponent: {
    en: "The opponent",
    ru: "Соперник",
  },
  name: {
    en: "Domino Puzzle",
    ru: "Домино пазл",
  },
};

export var getLanguage = function () {
  if (!window.ysdk) {
    return "en";
  } else {
    var language = window.ysdk.environment.i18n.lang;
    if (language !== "en" && language !== "ru") {
      return "en";
    } else {
      return language;
    }
  }
};
